<template>
  <div class="reported-content-media-preview">
    <AulaImg v-if="media.mediaType == mediaTypes.IMAGE" class="img-fluid" :img-url="media.file.url" />
    <video
      v-if="media.mediaType == mediaTypes.VIDEO"
      slot="img"
      class="video"
      :src="media.file.url"
      controls
      controlsList="nodownload"
    />
    <audio v-if="media.mediaType == mediaTypes.SOUND" slot="img" class="audio" :src="media.file.url" controls />
    <h2>{{ media.title }}</h2>
    {{ $getText('GALLERY_CREATOR') }}: {{ $getProfileDisplayName(media.creator) }}<br />
    {{ $getText('GALLERY_CREATED') }}: {{ createdDate }}<br />
    {{ media.description }}<br v-if="media.description" />
    <template v-if="media.tags != null && media.tags.length > 0">
      {{ $getText('GALLERY_TAGS') }}:
      {{ media.tags.map(tag => $getProfileDisplayName(tag)).join(', ') }}
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { mediaTypes } from '../enums/mediaTypes';
import AulaImg from './AulaImg';
import { DateTimeUtil } from '../utils/dateTimeUtil';

export default {
  components: { AulaImg },
  props: {
    media: { type: Object, default: null },
  },
  data: function () {
    return {
      mediaTypes: mediaTypes,
      Vue: Vue,
    };
  },
  computed: {
    createdDate() {
      return DateTimeUtil.longDate(this.media?.file?.created, true);
    },
  },
};
</script>
